module.exports = __webpack_public_path__ + "static/media/logo-bonuskit.d10fa4ec.png";